module.exports = __webpack_public_path__ + "static/team-1-e3f0dae1bba572c818d1b8daa1149109.png";